var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMindfullness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 172,
    viewBox: "0 0 156 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_582)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.124,
    y: 32.8902,
    width: 89.751,
    height: 106.069,
    rx: 4.89551,
    fill: "url(#paint0_linear_402_582)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2958 125.343L53.1535 125.606L53.302 125.355V132.3L53.1535 132.094L54.2958 132.334V132.825H51.4515V132.334L52.6167 132.094L52.4339 132.3V125.892L52.5824 125.903L49.9894 130.746L49.3611 130.792L46.8481 125.88L46.9852 125.869V132.3L46.8481 132.106L47.979 132.334V132.825H45.2261V132.334L46.3684 132.094L46.2084 132.3V125.355L46.3684 125.606L45.2261 125.4V124.909L47.3621 124.852L49.8409 129.867H49.7038L52.2626 124.909L54.2958 124.852V125.343Z",
    fill: "url(#paint1_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0787 132.243L56.9759 132.117L57.9697 132.334V132.825H55.2739V132.334L56.2677 132.117L56.1649 132.243V127.422L56.2563 127.525L55.2739 127.319V126.828L57.0787 126.76V132.243ZM56.5533 125.526C56.3781 125.526 56.2334 125.469 56.1192 125.355C56.005 125.24 55.9478 125.084 55.9478 124.886C55.9478 124.681 56.005 124.525 56.1192 124.418C56.241 124.304 56.3895 124.247 56.5647 124.247C56.7474 124.247 56.8959 124.3 57.0102 124.407C57.1244 124.513 57.1815 124.673 57.1815 124.886C57.1815 125.092 57.1206 125.252 56.9987 125.366C56.8769 125.473 56.7284 125.526 56.5533 125.526Z",
    fill: "url(#paint2_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6762 132.825V132.334L59.7043 132.106L59.5672 132.277V127.365L59.7043 127.536L58.6762 127.319V126.828L60.2754 126.748L60.4011 127.868L60.2754 127.822C60.6562 127.434 61.0522 127.148 61.4634 126.965C61.8822 126.783 62.2782 126.691 62.6514 126.691C63.154 126.691 63.569 126.847 63.8965 127.159C64.2315 127.464 64.3953 127.94 64.3876 128.587V132.277L64.2734 132.117L65.2786 132.334V132.825H62.6171V132.334L63.6109 132.117L63.4738 132.288V128.782C63.4738 128.309 63.3672 127.963 63.154 127.742C62.9407 127.521 62.6552 127.411 62.2973 127.411C62.0155 127.411 61.7071 127.487 61.372 127.639C61.0445 127.792 60.7209 128.028 60.4011 128.347L60.481 128.165V132.288L60.3668 132.128L61.3377 132.334V132.825H58.6762Z",
    fill: "url(#paint3_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2693 132.928C67.8504 132.928 67.4697 132.814 67.127 132.585C66.7843 132.349 66.514 132.007 66.316 131.557C66.118 131.1 66.019 130.548 66.019 129.901C66.019 128.842 66.2893 128.043 66.83 127.502C67.3707 126.961 68.1132 126.691 69.0574 126.691C69.2554 126.691 69.4611 126.706 69.6743 126.737C69.8951 126.767 70.1198 126.813 70.3482 126.874L70.1655 126.977V124.681L70.2683 124.806L69.2174 124.578V124.087L71.0793 124.007V132.265L70.9422 132.106L71.9703 132.311V132.814L70.3711 132.882L70.234 131.9L70.3482 131.946C70.0055 132.273 69.659 132.521 69.3087 132.688C68.9661 132.848 68.6196 132.928 68.2693 132.928ZM68.5891 132.231C68.8556 132.231 69.1298 132.163 69.4116 132.026C69.7009 131.881 69.9903 131.668 70.2797 131.386L70.1655 131.694V127.365L70.2911 127.594C69.8266 127.441 69.4039 127.365 69.0232 127.365C68.353 127.365 67.8428 127.582 67.4925 128.016C67.1422 128.45 66.9671 129.052 66.9671 129.821C66.9671 130.324 67.0356 130.758 67.1727 131.123C67.3174 131.481 67.5116 131.755 67.7552 131.946C68.0065 132.136 68.2845 132.231 68.5891 132.231Z",
    fill: "url(#paint4_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6873 132.825V132.334L73.6925 132.117L73.5783 132.254V127.354L73.6925 127.479H72.6645V126.977L73.7154 126.828L73.5783 127V126.04C73.5783 125.324 73.7611 124.799 74.1266 124.464C74.4997 124.121 74.9871 123.95 75.5887 123.95C75.7867 123.95 75.9885 123.969 76.1941 124.007C76.3997 124.037 76.6168 124.091 76.8452 124.167L76.6967 124.795C76.5216 124.742 76.3541 124.7 76.1941 124.669C76.0342 124.639 75.8781 124.624 75.7258 124.624C75.3527 124.624 75.0519 124.73 74.8234 124.943C74.6026 125.157 74.4921 125.496 74.4921 125.96V127L74.3436 126.84H76.0913L76.0685 127.479H74.3779L74.4921 127.354V132.243L74.3779 132.117L75.5773 132.334V132.825H72.6873Z",
    fill: "url(#paint5_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.068 132.928C78.5654 132.928 78.1503 132.772 77.8229 132.46C77.4954 132.147 77.3317 131.668 77.3317 131.02V127.377L77.4459 127.536L76.4293 127.319V126.828L78.2455 126.76V130.86C78.2455 131.317 78.3521 131.656 78.5654 131.877C78.7786 132.098 79.0642 132.208 79.4221 132.208C79.7038 132.208 80.0084 132.132 80.3359 131.98C80.6634 131.828 80.987 131.592 81.3068 131.272L81.2383 131.477V127.354L81.3525 127.536L80.3359 127.319V126.828L82.1521 126.748V132.265L82.0151 132.117L83.0431 132.311V132.814L81.4439 132.882L81.3068 131.751L81.4325 131.797C81.0593 132.186 80.6634 132.471 80.2445 132.654C79.8333 132.837 79.4411 132.928 79.068 132.928Z",
    fill: "url(#paint6_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4204 132.243L85.3176 132.117L86.3114 132.334V132.825H83.6042V132.334L84.598 132.117L84.5066 132.243V124.681L84.598 124.784L83.6042 124.578V124.087L85.4204 124.007V132.243Z",
    fill: "url(#paint7_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0214 132.825V132.334L88.0494 132.106L87.9124 132.277V127.365L88.0494 127.536L87.0214 127.319V126.828L88.6206 126.748L88.7462 127.868L88.6206 127.822C89.0014 127.434 89.3973 127.148 89.8086 126.965C90.2274 126.783 90.6234 126.691 90.9965 126.691C91.4992 126.691 91.9142 126.847 92.2416 127.159C92.5767 127.464 92.7404 127.94 92.7328 128.587V132.277L92.6186 132.117L93.6238 132.334V132.825H90.9623V132.334L91.9561 132.117L91.819 132.288V128.782C91.819 128.309 91.7124 127.963 91.4992 127.742C91.2859 127.521 91.0004 127.411 90.6424 127.411C90.3607 127.411 90.0523 127.487 89.7172 127.639C89.3897 127.792 89.0661 128.028 88.7462 128.347L88.8262 128.165V132.288L88.712 132.128L89.6829 132.334V132.825H87.0214Z",
    fill: "url(#paint8_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9686 132.928C96.4583 132.928 96.0052 132.814 95.6092 132.585C95.2209 132.349 94.9162 132.007 94.6954 131.557C94.4746 131.108 94.3641 130.56 94.3641 129.912C94.3641 129.25 94.4784 128.679 94.7068 128.199C94.9353 127.719 95.2589 127.35 95.6778 127.091C96.0966 126.824 96.5878 126.691 97.1513 126.691C97.6844 126.691 98.1223 126.805 98.4649 127.034C98.8152 127.255 99.0742 127.563 99.2417 127.959C99.4169 128.355 99.5044 128.808 99.5044 129.318C99.5044 129.402 99.5006 129.486 99.493 129.57C99.4854 129.653 99.474 129.756 99.4587 129.878H95.0609V129.227H98.6591L98.5563 129.296C98.5639 128.953 98.5221 128.637 98.4307 128.347C98.3393 128.058 98.1832 127.826 97.9623 127.651C97.7415 127.475 97.4483 127.388 97.0828 127.388C96.6944 127.388 96.3669 127.491 96.1004 127.696C95.8339 127.902 95.6359 128.184 95.5064 128.542C95.377 128.9 95.3122 129.315 95.3122 129.787C95.3122 130.289 95.3846 130.723 95.5293 131.089C95.674 131.447 95.8834 131.725 96.1575 131.923C96.4393 132.121 96.782 132.22 97.1856 132.22C97.4674 132.22 97.7758 132.166 98.1108 132.06C98.4459 131.946 98.7924 131.774 99.1503 131.546L99.4816 132.06C99.0551 132.349 98.6287 132.566 98.2022 132.711C97.7758 132.856 97.3645 132.928 96.9686 132.928Z",
    fill: "url(#paint9_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.65 128.256C101.65 128.5 101.73 128.69 101.89 128.827C102.05 128.964 102.256 129.079 102.507 129.17C102.759 129.254 103.025 129.337 103.307 129.421C103.589 129.505 103.855 129.608 104.106 129.73C104.358 129.851 104.563 130.019 104.723 130.232C104.883 130.445 104.963 130.727 104.963 131.078C104.963 131.481 104.853 131.82 104.632 132.094C104.411 132.368 104.11 132.578 103.729 132.722C103.356 132.859 102.937 132.928 102.473 132.928C102.191 132.928 101.902 132.905 101.605 132.859C101.308 132.814 101.003 132.749 100.691 132.665L100.771 131.135H101.354L101.468 132.254L101.365 132.128C101.54 132.174 101.73 132.212 101.936 132.243C102.142 132.273 102.332 132.288 102.507 132.288C102.781 132.288 103.033 132.25 103.261 132.174C103.497 132.09 103.688 131.972 103.832 131.82C103.977 131.66 104.049 131.462 104.049 131.226C104.049 130.975 103.969 130.777 103.809 130.632C103.657 130.487 103.455 130.369 103.204 130.278C102.953 130.187 102.686 130.103 102.404 130.027C102.13 129.943 101.868 129.84 101.616 129.718C101.365 129.589 101.159 129.421 100.999 129.216C100.839 129.01 100.76 128.728 100.76 128.37C100.76 127.982 100.859 127.666 101.057 127.422C101.262 127.171 101.529 126.988 101.856 126.874C102.191 126.752 102.549 126.691 102.93 126.691C103.189 126.691 103.474 126.718 103.787 126.771C104.099 126.824 104.419 126.904 104.746 127.011L104.689 128.302H104.106L103.935 127.354L104.072 127.514C103.676 127.399 103.303 127.342 102.953 127.342C102.58 127.342 102.267 127.422 102.016 127.582C101.772 127.734 101.65 127.959 101.65 128.256Z",
    fill: "url(#paint10_linear_402_582)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.105 128.256C107.105 128.5 107.185 128.69 107.345 128.827C107.505 128.964 107.711 129.079 107.962 129.17C108.213 129.254 108.48 129.337 108.762 129.421C109.043 129.505 109.31 129.608 109.561 129.73C109.813 129.851 110.018 130.019 110.178 130.232C110.338 130.445 110.418 130.727 110.418 131.078C110.418 131.481 110.308 131.82 110.087 132.094C109.866 132.368 109.565 132.578 109.184 132.722C108.811 132.859 108.392 132.928 107.928 132.928C107.646 132.928 107.357 132.905 107.06 132.859C106.763 132.814 106.458 132.749 106.146 132.665L106.226 131.135H106.808L106.923 132.254L106.82 132.128C106.995 132.174 107.185 132.212 107.391 132.243C107.597 132.273 107.787 132.288 107.962 132.288C108.236 132.288 108.488 132.25 108.716 132.174C108.952 132.09 109.142 131.972 109.287 131.82C109.432 131.66 109.504 131.462 109.504 131.226C109.504 130.975 109.424 130.777 109.264 130.632C109.112 130.487 108.91 130.369 108.659 130.278C108.408 130.187 108.141 130.103 107.859 130.027C107.585 129.943 107.322 129.84 107.071 129.718C106.82 129.589 106.614 129.421 106.454 129.216C106.294 129.01 106.214 128.728 106.214 128.37C106.214 127.982 106.313 127.666 106.511 127.422C106.717 127.171 106.984 126.988 107.311 126.874C107.646 126.752 108.004 126.691 108.385 126.691C108.644 126.691 108.929 126.718 109.241 126.771C109.554 126.824 109.873 126.904 110.201 127.011L110.144 128.302H109.561L109.39 127.354L109.527 127.514C109.131 127.399 108.758 127.342 108.408 127.342C108.034 127.342 107.722 127.422 107.471 127.582C107.227 127.734 107.105 127.959 107.105 128.256Z",
    fill: "url(#paint11_linear_402_582)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8495 79.0031C84.2034 79.0031 79.2451 81.9359 76.4058 86.3589C79.2454 90.7817 84.2034 93.7148 89.8495 93.7148C95.4957 93.7148 100.454 90.782 103.293 86.3589C100.454 81.9363 95.4957 79.0031 89.8495 79.0031Z",
    fill: "#3D88A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7817 79.0031C73.4278 79.0031 78.3861 81.9359 81.2255 86.3589C78.3858 90.7817 73.4278 93.7148 67.7817 93.7148C62.1355 93.7148 57.1773 90.782 54.3379 86.3589C57.1775 81.9363 62.1355 79.0031 67.7817 79.0031Z",
    fill: "#51B9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4688 73.7462C79.1666 78.0475 77.6236 84.0595 78.83 89.593C84.3638 90.8003 90.3764 89.2584 94.6787 84.9574C98.9809 80.6563 100.524 74.6441 99.3175 69.1106C93.7837 67.903 87.7711 69.4449 83.4688 73.7462Z",
    fill: "#64E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1635 73.7462C78.4658 78.0475 80.0087 84.0595 78.8024 89.593C73.2686 90.8003 67.256 89.2584 62.9537 84.9574C58.6514 80.6563 57.1085 74.6441 58.3149 69.1106C63.8486 67.903 69.8613 69.4449 74.1635 73.7462Z",
    fill: "#6ED4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8896 75.1175C70.8896 81.2015 74.0501 86.5438 78.8157 89.6036C83.5814 86.544 86.7418 81.2015 86.7418 75.1175C86.7418 69.0335 83.5814 63.6912 78.8157 60.6315C74.0501 63.6912 70.8896 69.0336 70.8896 75.1175Z",
    fill: "#64E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.742 75.1175C86.742 69.0336 83.5816 63.6911 78.8159 60.6313V89.6032C83.5816 86.5439 86.742 81.2015 86.742 75.1175Z",
    fill: "#51B9C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_582",
    x: 0.487305,
    y: 0.253479,
    width: 155.024,
    height: 171.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_582",
    x: 12.5894,
    y: 94.5766,
    width: 130.465,
    height: 74.2518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_582",
    x: 21.7012,
    y: 31.2583,
    width: 114.229,
    height: 98.3569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.26367
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.3184
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.890196 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_582",
    x1: 77.9995,
    y1: 32.8902,
    x2: 77.9995,
    y2: 138.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#2C2C2C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_402_582",
    x1: 28.1824,
    y1: 135.825,
    x2: 127.554,
    y2: 135.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindfullness);
export default __webpack_public_path__ + "static/media/mindfullness.348ea160d196d9bb67e9eb67260e6029.svg";
export { ForwardRef as ReactComponent };